export type ReviewSeverity = 'critical' | 'warning' | 'info';

export type ReviewFindingLike = {
  paragraphIndex: number;
};

export type ReviewFindingsLike<T extends ReviewFindingLike> = {
  critical: T[];
  warning: T[];
  info: T[];
};

export type FlattenedReviewFinding<T extends ReviewFindingLike> = {
  finding: T;
  category: ReviewSeverity;
};

const SEVERITY_RANK: Record<ReviewSeverity, number> = {
  critical: 0,
  warning: 1,
  info: 2,
};

/** Flatten severity buckets into document order (paragraph index, then severity). */
export function flattenFindingsChronologically<T extends ReviewFindingLike>(
  findings: ReviewFindingsLike<T>,
): FlattenedReviewFinding<T>[] {
  const rows: FlattenedReviewFinding<T>[] = [
    ...findings.critical.map((finding) => ({ finding, category: 'critical' as const })),
    ...findings.warning.map((finding) => ({ finding, category: 'warning' as const })),
    ...findings.info.map((finding) => ({ finding, category: 'info' as const })),
  ];
  rows.sort((a, b) => {
    const byParagraph = a.finding.paragraphIndex - b.finding.paragraphIndex;
    if (byParagraph !== 0) return byParagraph;
    return SEVERITY_RANK[a.category] - SEVERITY_RANK[b.category];
  });
  return rows;
}
